import axios from "axios";
import {httpDelete, httpGet, httpPost} from "./index";

const refreshCsrfCookie = async () => {
    await axios.get('/sanctum/csrf-cookie');
};

export const getForm = async () => {
    const response = await httpGet('/v1/studio-registers/form?include=amenities,studio-register-gallery');
    if (response) {
        return response.data;
    }
};

export const saveStep = async (id, step, data) => {
    await refreshCsrfCookie();
    const response = await httpPost(`/v1/studio-registers/${id}/${step}`, data);
    if (response) {
        return response.data;
    }
};

export const uploadLogo = async (id, data) => {
    const response = await httpPost(`/v1/studio-registers/${id}/upload-logo`, data);
    if (response) {
        return response.data;
    }
};

export const cropLogo = async (id, data) => {
    const response = await httpPost(`/v1/studio-registers/${id}/crop-logo`, data);
    if (response) {
        return response.data;
    }
};

export const uploadImage = async (data) => {
    const response = await httpPost(`/v1/studio-register-gallery`, data);
    if (response) {
        return response.data;
    }
};

export const cropImage = async (id, data) => {
    const response = await httpPost(`/v1/studio-register-gallery/${id}/crop`, data);
    if (response) {
        return response.data;
    }
};

export const replaceImage = async (id, data) => {
    const response = await httpPost(`/v1/studio-register-gallery/${id}`, data);
    if (response) {
        return response.data;
    }
};

export const deleteImage = async (id) => {
    const response = await httpDelete(`/v1/studio-register-gallery/${id}`);
    if (response) {
        return response.data;
    }
};

export const sortImages = async (id, data) => {
    const response = await httpPost(`/v1/studio-registers/${id}/sort-images`, data);
    if (response) {
        return response.data;
    }
};
